import { Component } from '@angular/core';
import { ApiConfiguration } from './api/api-configuration';
import { EnvironmentLoaderService } from './services/environment-loader.service';
import { CustomIconService } from './services/custom-icon.service';
import { AuthService } from './auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'OK-EGIS-Portal-Ekstern';

  constructor(
    private customIconService: CustomIconService,
    private api: ApiConfiguration,
    private environmentLoader: EnvironmentLoaderService,
    private authService: AuthService
  ) {
    this.customIconService.init();
    const baseUrl = this.environmentLoader.config.egisServiceBaseUrl;
    this.api.rootUrl = baseUrl;
  }

  logout() {
    this.authService.logout();
  }
}
